module.exports = __webpack_public_path__ + "static/media/editNew.8b9e8bc1.svg";